$(document).ready(function() {
  var j = 0;

  if (navigator.appVersion.indexOf('Edge') !== -1) {
    $('.ph-formlabel').addClass('ph-formlabeledge');
  }

  $('#orgType option').each(function() {
    if (j > 0) {
      $(this).data('phyInfoStatus', $('#orgTypeArrayitem' + j).html());
    }

    j = j + 1;
  });

  function uploadDocument() {
    $('#uploadDocFile1').click(function() {
      $('#uploadErrorMessage,#uploadSuccessfulMsg').hide();

      var formData = new FormData(document.getElementById('registerForm'));
      var $fld = $('#preview');

      if ((/(\.exe)$/i).test($fld.val()) || $fld.val() === '') {
        $('#uploadErrorMessage').show();
      } else {
        $.ajax({
          url: '/register/previewUpload',
          type: 'post',
          data: formData,
          contentType: false,
          processData: false,
          enctype: 'multipart/form-data',
          success: function(data) {
            if (data === true) {
              $('#uploadSuccessfulMsg').show();
            } else {
              $('#uploadErrorMessage').show();
            }
          }
        });
      }
    });
  }

  function uploadSecondDocument() {
    $('#uploadDocFile2').click(function() {
      $('#uploadErrorMessage2,#uploadSuccessfulMsg2').hide();

      var formData = new FormData();
      var $fldsec = $('#bankReference');

      formData.append($fldsec);

      if ((/(\.exe)$/i).test($fldsec.val()) || $fldsec.val() === '') {
        $('#uploadErrorMessage2').show();
      } else {
        $.ajax({
          url: '/register/bankReferenceUpload',
          type: 'post',
          data: formData,
          contentType: false,
          processData: false,
          enctype: 'multipart/form-data',
          success: function(data) {
            if (data === true) {
              $('#uploadSuccessfulMsg2').show();
            } else {
              $('#uploadErrorMessage2').show();
            }
          }
        });
      }
    });
  }

  uploadDocument();
  uploadSecondDocument();


  function showHidePhysicianInfo() {
    if ($('#orgType option:selected').data('phyInfoStatus') === 'true') {
      $('#physicianInformations').removeClass('hidden').addClass('ph-physician');
      $('#physicianInformations').find('input,select').attr('disabled', false);
    } else {
      $('.ph-physician .ph-signup__error').removeClass('form_field_error ph-form_field_error');
      $('.ph-physician .ph-register__emptyvalue').text('');
      $('#physicianInformations').addClass('hidden').removeClass('ph-physician');
      $('#physicianInformations').find('input,select').attr('disabled', true);
    }
  }

  showHidePhysicianInfo();

  $('#orgType').change(function() {
    showHidePhysicianInfo();
  });

  function toggleNewCustomerPart(toggletask) {
    if (toggletask === true) {
      $('.newCustomer').hide();
      $('.ph-diff_address').show();
      $('.ph-sameasbilling').hide();
      $('#ph-identifierNumber').show();
      $('.ph-customergroup_selection').addClass('hidden');
    } else {
      $('.newCustomer').hide();
      $('#ph-identifierNumber').show();
      $('.ph-diff_address').show();
      $('.ph-sameasbilling').hide();
      /* $('.ph-registration__organ').find('#shippingOrganization').show();
         $('.ph-registration__organ').find('#billingOrganization').show(); */
      $('#customerGroupSelection').removeClass('hidden');
      $('#customerGroupSelect').trigger('change');
    }
  }

  $(document).on('change', '#customerGroupSelect', function() {
    var customerGroupSelectValue = String($(this).val()),
        comparableKeyForOther = String($('.ph-comparable_key_other').text());

    if (customerGroupSelectValue.toLowerCase() === comparableKeyForOther.toLowerCase()) {
      $('#customerGroupNameDiv').removeClass('hidden');
      $('#customerGroupName').val('');
    } else {
      $('#customerGroupNameDiv').addClass('hidden');
      $('#customerGroupName').val(customerGroupSelectValue);
    }
  });

  function callregisterStatements() {
    if ($('.haveHealthCareAcct-radio:checked').val() === 'Yes') {
      $('.ph-bignumber').hide();
      $('.ph-vatregistrationNumber,.ph-registrationNumber').hide();
      $('.ph-commercenumber').hide();
      $('.ph-registrationSiret').hide();
    } else {
      $('.ph-bignumber').show();
      $('.ph-vatregistrationNumber,.ph-registrationNumber').show();
      $('.ph-commercenumber').show();
      $('.ph-registrationSiret').show();
    }

    $('.newCustomer .ph-signup__error').removeClass('form_field_error ph-form_field_error');
    $('.ph-registration__organ').removeClass('ph-registration__second');
    $('.newCustomer .ph-signup__error .ph-register__emptyvalue').html('');
  }

  function sapCust(selected) {
    var allownewsapuser = $('.allowNewSAPUser').val();

    if (selected.val() === 'Yes' || allownewsapuser === 'false') {
      toggleNewCustomerPart(true);
      $('.newCustomer').find('input,select').attr('disabled', true);
      $('.custAccountNumber input').attr('disabled', false);
      $('.custAccountNumber').show();
      $('.ph-registrationNumber input').attr('disabled', true);
      $('.ph-registrationNumber').hide();
      $('.ph-registrationSiret input').attr('disabled', true);
      $('.ph-registrationSiret').hide();
      $('.ph-documents').hide();
    } else {
      toggleNewCustomerPart(false);
      $('.newCustomer').find('input,select').attr('disabled', false);
      $('.custAccountNumber input').attr('disabled', true);
      $('.custAccountNumber').hide();
      $('.ph-registrationNumber input').attr('disabled', false);
      $('.ph-registrationNumber').show();
      $('.ph-registrationSiret input').attr('disabled', false);
      $('.ph-registrationSiret').show();
      $('.ph-documents').show();
    }
  }


  $(document).on('click', '.haveHealthCareAcct-radio', function() {
    var $selected = $(this);

    sapCust($selected);
  });


  if ($('.page-register').length > 0) {
    $(document).on('click', '.haveHealthCareAcct-radio', function() {
      callregisterStatements();
    });
  }

  $(window).on('load', function() {
    var $selected = $('.haveHealthCareAcct-radio:checked');

    if ($selected.length > 0) {
      if ($selected[0].value === 'Yes') {
        $('.ph-commercenumber').hide();
      } else if ($selected[0].value === 'No') {
        $('.ph-commercenumber').show();
      }
    }

    callregisterStatements();
    sapCust($selected);
    /* eslint-disable no-use-before-define */
    addShippingAddressStatus($('#shipOrgChecked1'));
    /* eslint-enable no-use-before-define */
  });
});

/* eslint-disable no-implicit-globals */
function disbaleEnableAdditionalAddress() {
  /* eslint-enable no-implicit-globals */
  var billingOrganization = $('#billingOrganization .address-holder').length;
  var shippingOrganization = $('#shippingOrganization .address-holder').length;

  // Alert(shippingOrganization)
  if (shippingOrganization >= 8) {
    $('#addShippingAddress').addClass('ph-addtional-address__disable');
  } else {
    $('#addShippingAddress').removeClass('ph-addtional-address__disable');
  }

  if (billingOrganization >= 8) {
    $('#addBillingAddress').addClass('ph-addtional-address__disable');
  } else {
    $('#addBillingAddress').removeClass('ph-addtional-address__disable');
  }
}

/* eslint-disable no-implicit-globals */
function addShippingAddressStatus(obj) {
  /* eslint-enable no-implicit-globals */
  if ($(obj).is(':checked')) {
    $('select#shipOrgState, select#shipOrgCountry').show();
    $('#shipOrgStateLabel, #shipOrgCountryLabel').find('.selectBox-dropdown').hide();
    $('#addShippingAddress').addClass('hidden');
    $('#shippingOrganization').find('input,select').attr('disabled', true).addClass('disable ph-disable');
    $(obj).attr('disabled', false);
  } else {
    ACC.validation.additionalShippingAddressPostalCheck();

    $('select#shipOrgState, select#shipOrgCountry').hide();
    $('#shipOrgStateLabel, #shipOrgCountryLabel').find('.selectBox-dropdown').show();
    $('#addShippingAddress').removeClass('hidden');
    $('#shippingOrganization').find('input,select').attr('disabled', false).removeClass('disable ph-disable');
  }
}

$('#shipOrgChecked1').change(function() {
  addShippingAddressStatus($(this));
});

/* eslint-disable no-implicit-globals */
var billingAddressCount = 1,
    shippingAddressCount = 1;

$(document).on('click', '#addBillingAddress', function() {
  /* eslint-enable no-implicit-globals */
  var holderLength = $('#billingOrganization .address-holder').length;

  if (holderLength <= 7) {
    $('#addBillingAddress').before($('#billingAddressTemplate').tmpl({
      count: billingAddressCount
    }));

    ACC.validation.getCountryList('true');

    ACC.validation.currentLocale = ACC.validation.getStoreID();
    document.querySelector('#billOrgCountry' + billingAddressCount).value = ACC.validation.currentLocale;

    ACC.validation.stateListMain('billOrgCountry' + billingAddressCount, 'false');
  }

  $('#billingOrganization .address-holder:last input').each(function() {
    $(this).attr('name', $(this).attr('name').replace(1, billingAddressCount));
  });

  if (!$('#billingOrganization .address-holder:last select')) {
    $('#billingOrganization .address-holder:last select').attr('name', $(this).attr('name').replace(1, billingAddressCount));
  }

  billingAddressCount = billingAddressCount + 1;
  disbaleEnableAdditionalAddress();
  $('#billingOrganization .ph-customselectbox ').find('select').selectBox();
});

$(document).on('click', '#addShippingAddress', function() {
  var holderLength = $('#shippingOrganization .address-holder').length;

  if (holderLength <= 7) {
    $('#addShippingAddress').before($('#shippingAddressTemplate').tmpl({
      count: shippingAddressCount
    }));

    ACC.validation.getCountryList('true');

    ACC.validation.currentLocale = ACC.validation.getStoreID();
    document.querySelector('#shipOrgCountry' + shippingAddressCount).value = ACC.validation.currentLocale;

    ACC.validation.stateListMain('shipOrgCountry' + shippingAddressCount, 'false');
  }

  $('#shippingOrganization .address-holder:last input').each(function() {
    $(this).attr('name', $(this).attr('name').replace(1, shippingAddressCount));
  });

  if (!$('#shippingOrganization .address-holder:last select')) {
    $('#shippingOrganization .address-holder:last select').attr('name', $(this).attr('name').replace(1, shippingAddressCount));
  }

  shippingAddressCount = shippingAddressCount + 1;
  disbaleEnableAdditionalAddress();
  $('#shippingOrganization .ph-customselectbox ').find('select').selectBox();
});

$(document).on('click', '.deleteAddress', function() {
  $(this).parents('.address-holder,.form-section.ph-clearfix ').remove();
  disbaleEnableAdditionalAddress();
});


/* eslint-disable no-implicit-globals */
/* eslint-disable no-unused-vars */
function validatePhoneNumber(evt) {
  /* eslint-enable no-implicit-globals */
  /* eslint-enable no-unused-vars */
  var event = evt || window.event,
      val = event.target.value,
      filtered = val.replace(/\D/g, '');

  if (filtered !== val) {
    event.target.value = filtered;
  }
}

$(document).ready(function() {
  if ($('.ph-feedbackform').length > 0) {
    $('.ph-feedbackform').find('.ph-form__fieldwrap .ph-form_field_error .form_field-input')
      .append('<span class="ph-exclamation-mark"></span>');
    $('.ph-feedbackform').find('input, textarea, select').focus(function() {
      $(this).parent().parent().addClass('ph-focusing');
    }).blur(function() {
      $(this).parent().parent().removeClass('ph-focusing');
    });
  }

  if ($('.ph-mycompanyform').length > 0) {
    $('.ph-mycompanyform').find('.ph-form__fieldwrap .ph-form_field_error .form_field-input')
      .append('<span class="ph-exclamation-mark"></span>');
    $('.ph-mycompanyform').find('input, textarea, select').focus(function() {
      $(this).parent().parent().addClass('ph-focusing');
    }).blur(function() {
      $(this).parent().parent().removeClass('ph-focusing');
    });
  }

  if ($('.trackNewRegistration').length > 0) {
    ACC.omniture.bindTrackConversion('user_registration', 'new_registration');
  }
});
